import { useEffect, useRef } from "react";

// Custom setInterval hook by Dan Abramov
export const useInterval = (
  callback: () => void,
  delay: number,
  gameOver: boolean
) => {
  const savedCallback = useRef<any>();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (gameOver === false) {
        savedCallback.current();
        const gameControllerInput = document.querySelector(
          ".GameController"
        ) as HTMLInputElement;
        gameControllerInput.focus();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => {
        clearInterval(id);
      };
    }
  }, [delay, gameOver]);
};
